import { render, staticRenderFns } from "./V2ShipAllCollectionStep.vue?vue&type=template&id=4d6966e3&scoped=true&"
import script from "./V2ShipAllCollectionStep.vue?vue&type=script&lang=js&"
export * from "./V2ShipAllCollectionStep.vue?vue&type=script&lang=js&"
import style0 from "./V2ShipAllCollectionStep.vue?vue&type=style&index=0&id=4d6966e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6966e3",
  null
  
)

export default component.exports